class @App.Components.Feedback
  constructor: ->
    $body = $('body')
    @forms = '[data-component="feedback"]'
    @commentsBoxes = '[data-component="feedback-comments"]'

    $body.on 'click', () =>
      $(@commentsBoxes).hide()

    $body.on 'click', @forms, (e) ->
      e.stopPropagation() # prevent bubbling
      return

    $body.on 'click', @forms + ' [data-action="feedback-rate"]', @showCommentsForm

    $body.on 'click', @forms + ' [data-action="feedback-submit"]', @submitFeedback

    return

  submitFeedback: (e) =>
    $target = $(e.target)
    # rails event handler submits the form
    # $target.closest(@forms).submit()
    $target.closest(@forms).find(@commentsBoxes).hide()
    return

  showCommentsForm: (e) =>
    $(e.target).closest(@forms).find(@commentsBoxes).show()
    return

$ ->
  new App.Components.Feedback
